<template>
  <b-modal
    id="modal-print-conf"
    ref="bModal"
    centered
    :title="$t('printService.printerNotConfigured')"
    modal-class="modalPrintConfiguration"
  >
    <b-row class="pt-3">
      <b-col class="text-center">
        <div class="d-flex flex-column">
          <div style="position:relative">
            <i
              class="fal fa-print fa-2x main py-2"
              aria-hidden="true"
            />
            <i
              class="far fa-cogs main"
              style="position:absolute;top:6px;"
              aria-hidden="true"
            />
          </div>
          <span class="main">{{ $t('printService.necessaryToConfigure') }}</span>
          <p class="mt-2">
            {{ $t('printService.accessUserSettings') }}
          </p>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            :class="{'btn-sm': $route.name != 'ContentTracking'}"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :class="{'btn-sm': $route.name != 'ContentTracking'}"
            class="btn--primary"
            @click="hideAndShowModalUserConf"
          >
            <i
              class="fal fa-cog mr-2"
              aria-hidden="true"
            />
            {{ $t('printService.configureNow') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
    name: 'ModalPrintConfiguration',
    data() {
        return {
        }
    },
    methods: {
        show() {
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        hideAndShowModalUserConf() {
            if (this.$route.name === 'ContentTracking') {
                this.$emit('showModalUserConfTracking')
                this.$refs.bModal.hide()
            } else {
                this.$emit('showModalUserConf')
                this.$refs.bModal.hide()
            }
        }
    }
}

</script>

<style>

.modalPrintConfiguration .modal-body {
    border-radius: 0 0 0.3rem 0.3rem;
    height: auto;
}

.modalPrintConfiguration .modal-dialog {
    max-width: 420px;
}

</style>
